export const AUTH_SERVICE_URL = process.env.AUTH_SERVICE_URL ?? 'https://auth.api.vechain.energy'
export const WALLET_CONNECT_PROJECT_ID = process.env.WALLET_CONNECT_PROJECT_ID ?? 'abedfb5522e0bf261f577d874bf347f2'